'use strict';

/*@ngInject*/
module.exports = function($http) {
	var rssFeedUrl = 'https://api.rss2json.com/v1/api.json';
	var feedEntries = [];
	return {
		load: function(url, count) {
			var rssUrl = rssFeedUrl + '?rss_url=' + encodeURIComponent(url) + '&api_key=glc5rszdxaww41cir2vpgpt3dogrq8dgbl42obvx';
			return $http.get(rssUrl);

		}, 

		getFeed: function() {
			return feedEntries;
		},
		setFeed: function(entries) {
			feedEntries = entries;
		}
	};
};
